var MpPageBusiness;

(function() {
    if (!document.querySelector('#vue-body-business')) {
        return;
    }

    Vue.component('multiselect', window.VueMultiselect.default);

    MpPageBusiness = new Vue({
        el: '#vue-body-business',
        mixins: [MpPaginator, MpVideoModal],
        data: {
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',

            // Constants come from php BusinessController
            REGISTERED_OWNER: REGISTERED_OWNER,
            UNREGISTERED_OWNER: UNREGISTERED_OWNER,
            BUSINESS_DETAIL_PATH: '/business/detail/reference/',
            BUSINESS_SEARCH_PAGE_URL: '/business/index/format/json/type/',
            LOCATIONS_PATH: '/country/getLocations',
            TYPE: TYPE,

            totalResultsTPL: '',
            totalItems: 0,

            itemList: [],
            highlightsList: [],

            // Values for this block come from jsVarCollection at BusinessController
            idCountry: COUNTRY_ID,
            word: wordSearch,
            selectedZones: [],
            selectedProvinces: [],
            selectedLocations: [],

            filters: '',
            provincesPool: [],

            zonesCheckList: JSON.parse(ZONES),
            provincesCheckList: JSON.parse(PROVINCES),
            locationsCheckList: [],

            reloadHighlights: true,
            isSearchActive: false,

            overlay: null,

            isInitialized: false,
        },
        computed: {
            requestUrl: function() {
                return  this.BUSINESS_SEARCH_PAGE_URL + this.TYPE + '/page/' + this.page;
            },

            selectedZonesIds: function() {
                var selectedIds = [],
                    i;

                for (i=0; i<this.selectedZones.length; i++) {
                    selectedIds.push(this.selectedZones[i].id);
                }

                return selectedIds;
            },

            selectedProvincesIds: function() {
                var selectedIds = [],
                    i;

                for (i=0; i<this.selectedProvinces.length; i++) {
                    selectedIds.push(this.selectedProvinces[i].id);
                }

                return selectedIds;
            },

            selectedLocationsIds: function() {
                var selectedIds = [],
                    i;

                for (i=0; i<this.selectedLocations.length; i++) {
                    selectedIds.push(this.selectedLocations[i].id);
                }

                return selectedIds;
            },

            availableProvinces: function() {
                var _this = this;
                return this.provincesCheckList.filter(function (province) {
                    return _this.selectedZones.length && _this.selectedZonesIds.indexOf(province.zoneId) >= 0;
                });
            },

            provincesActive: function() {
                return this.availableProvinces.length > 0;
            },

            locationsActive: function() {
                return this.locationsCheckList.length > 0;
            },

            dataFilters: function() {
                return Serializer.serialize({
                    'word': this.word,
                    'zones': this.selectedZonesIds,
                    'provinces': this.selectedProvincesIds,
                    'locations': this.selectedLocationsIds,
                    'filters': this.filters,
                });
            },

            totalResults: function () {
                return this.totalResultsTPL.replace('%s', this.totalItems);
            },
        },
        methods: {

            filterByIds: function(list, idList) {
                return list.filter(function (item) {
                    return idList.indexOf(item.id) >= 0;
                });
            },

            getOwnerUrl: function(owner, id) {
                var ownerPath = (owner) ? owner : this.UNREGISTERED_OWNER;

                return this.BUSINESS_DETAIL_PATH + id + '/type/' +this.TYPE + '/owner/' + ownerPath;
            },

            addDomItem: function(item) {
                this.itemList.push({
                    id: item.getAttribute('data-reference'),
                    type: TYPE,
                    owner: item.querySelector('.js-item-owner').getAttribute('data-owner'),
                    name: item.querySelector('.js-item-owner').innerHTML.trim(),
                    address: item.querySelector('.js-item-address').innerHTML.trim(),
                    zipCode: item.querySelector('.js-item-zipcode').innerHTML.trim(),
                    province: item.querySelector('.js-item-province').innerHTML.trim(),
                    location: item.querySelector('.js-item-location').innerHTML.trim(),
                });
            },

            addCheck: function(type, checkItem) {
                this[type+'CheckList'].push(checkItem);

                if (checkItem.getAttribute('checked')) {
                    this[type].push(checkItem.value);
                }
            },

            initZonesSelector: function() {
                // zonesSearch comes from php BusinessController
                var zoneList;

                if (!zonesSearch) {
                    return;
                }

                this.selectedZones = this.filterByIds(this.zonesCheckList, JSON.parse(zonesSearch));
            },

            initProvincesSelector: function() {
                // provincesSearch comes from php BusinessController
                var i,
                    provinceList,
                    nProvinces;

                if (!provincesSearch) {
                    return;
                }

                provinceList = JSON.parse(provincesSearch);
                this.selectedProvinces = this.provincesCheckList.filter(function (province) {
                    return (provinceList.indexOf(province.id) >= 0);
                });

                nProvinces = this.selectedProvinces.length;
                for (i=0; i<nProvinces; i++) {
                    this.provincesPool.push(this.selectedProvinces[i].id);
                    this.onProvinceAdded(this.selectedProvinces[i]);
                }
            },

            initLocationsSelector: function() {
                // locationsSearch comes from php BusinessController
                var locationList;

                if (!locationsSearch) {
                    return;
                }

                locationList = JSON.parse(locationsSearch);
                this.selectedLocations = this.locationsCheckList.filter(function (location) {
                    return (locationList.indexOf(location.id) >= 0);
                });
            },

            initFilters: function() {
                this.initZonesSelector();
                this.initProvincesSelector();

                if (this.word || this.selectedZones.length) {
                    this.isSearchActive = true;
                }
            },

            showFilters: function() {
                this.isSearchActive = !this.isSearchActive;
            },

            resetFilters: function() {
                this.word = '';
                this.locationsCheckList = [];
                this.selectedZones = [];
                this.selectedProvinces = [];
                this.selectedLocations = [];
                this.loadItems();
            },

            onLocationsLoaded: function(provinceId, response) {
                if (response.status !== 200 || !response.data.locations) {
                    return;
                }

                var i,
                    location,
                    nLocations = response.data.locations.length;

                for (i=0; i<nLocations; i++) {
                    location = response.data.locations[i];
                    location.provinceId = provinceId;
                    this.locationsCheckList.push(location);
                }

                this.provincesPool.pop();
                if (!this.provincesPool.length) {
                    this.initLocationsSelector();
                }
            },

            onProvinceAdded: function(selectedOption, id) {
                axios
                    .post(this.LOCATIONS_PATH, Serializer.serialize({
                        idcountry: this.idCountry,
                        idzone: selectedOption.zoneId,
                        idprovince: selectedOption.id
                    }))
                    .then(this.onLocationsLoaded.bind(null, selectedOption.id))
                    .catch(function(error) {
                        console.log(error);
                    });
            },

            onProvinceRemoved: function(removedProvince, id) {
                var i;

                // Reverse iteration to avoid bugs with splice inside a loop
                for (i=this.selectedLocations.length-1; i>=0; i--) {
                    if (this.selectedLocations[i].provinceId === removedProvince.id) {
                        this.selectedLocations.splice(i, 1);
                    }
                }

                for (i=this.locationsCheckList.length-1; i>=0; i--) {
                    if (this.locationsCheckList[i].provinceId === removedProvince.id) {
                        this.locationsCheckList.splice(i, 1);
                    }
                }
            },

            onZoneRemoved: function(removedZone, id) {
                var i;
                for (i=this.selectedProvinces.length-1; i>=0; i--) {
                    if (this.selectedProvinces[i].zoneId === removedZone.id) {
                        this.onProvinceRemoved(this.selectedProvinces[i]);
                        this.selectedProvinces.splice(i, 1);
                    }
                }
            },

            onSearchLoaded: function(response) {
                if (response.data.result == this.RESPONSE_OK) {
                    this.itemList = response.data.business;
                    this.totalItems = response.data.total;
                    this.highlightsList = response.data.highlights;
                    this.updatePaginator(response);
                }
            },

            loadItems: function() {
                axios
                    .post(this.requestUrl, this.dataFilters)
                    .then(this.onSearchLoaded)
                    .catch(function(error) {
                        console.log(error);
                    });
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                window.addEventListener('hashchange', this.onHashChange);
                this.onHashChange();

                this.initPaginator();
                this.initFilters();
                this.isInitialized = true;
            },
        },

        mounted: function() {
            this.$refs.ssrPaginator.querySelectorAll('.js-page-item').forEach(this.addDomPage);
            this.$refs.ssrItemList.querySelectorAll('.js-item').forEach(this.addDomItem);

            this.totalResultsTPL = this.$refs.ssrTotalItems.getAttribute('data-tpl');
            this.totalItems = this.$refs.ssrTotalItems.getAttribute('data-total');

            this.word = this.$refs.wordSearch.getAttribute('data-init');
            this.filters = this.$refs.filters.getAttribute('data-init');

            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },

        destroy: function() {
            window.removeEventListener('hashchange', this.onHashChange);
        }
    });

})();
